import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'warm' | 'cool' | 'green' | 'dark' | 'black' | 'gradient-dark' | 'gradient-purple' | 'gradient-pink' | 'light-pink' | 'light-purple' | 'light-peach' | 'dreamy';
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white',
  containerSize = 'lg'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-cream text-navy',
    warm: 'bg-gradient-to-br from-cream to-blush text-navy',
    cool: 'bg-gradient-to-br from-blush to-dusty-rose/20 text-navy',
    green: 'bg-gradient-to-br from-cream to-dusty-rose/10 text-navy',
    dark: 'bg-navy text-cream',
    black: 'bg-navy text-cream',
    'gradient-dark': 'bg-gradient-to-br from-navy to-mauve text-cream',
    'gradient-purple': 'bg-gradient-to-br from-blush via-cream to-blush text-navy',
    'gradient-pink': 'bg-gradient-to-br from-cream via-blush to-dusty-rose/20 text-navy',
    'light-pink': 'bg-blush text-navy',
    'light-purple': 'bg-gradient-to-br from-cream to-mauve/10 text-navy',
    'light-peach': 'bg-gradient-to-br from-cream to-pink-highlight/20 text-navy',
    dreamy: 'text-navy'
  };
  const containers = {
    sm: 'max-w-3xl',
    md: 'max-w-4xl',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-full'
  };
  const isDreamy = background === 'dreamy';
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${backgrounds[background]} ${className} relative overflow-hidden`} data-id="element-341">
      {/* Dreamy background image layer */}
      {isDreamy && <div className="absolute inset-0 z-0" data-id="element-342">
          <img src="https://images.unsplash.com/photo-1490750967868-88aa4f44baee?w=1200&q=60" alt="" className="w-full h-full object-cover blur-2xl scale-110 opacity-40" aria-hidden="true" data-id="element-343" />
          <div className="absolute inset-0 bg-gradient-to-b from-cream/90 via-cream/85 to-cream/90" data-id="element-344" />
        </div>}

      {/* Subtle decorative elements */}
      <div className={`absolute top-0 right-0 ${isDreamy ? 'w-[600px] h-[600px]' : 'w-96 h-96'} bg-dusty-rose/10 rounded-full blur-3xl pointer-events-none`} data-id="element-345" />
      <div className={`absolute bottom-0 left-0 ${isDreamy ? 'w-[500px] h-[500px]' : 'w-96 h-96'} bg-mauve/10 rounded-full blur-3xl pointer-events-none`} data-id="element-346" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className={`mx-auto ${containers[containerSize]} relative z-10`} data-id="element-347">
        {children}
      </motion.div>
    </section>;
}